"use strict";

exports.__esModule = true;
exports.DateInput = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = require("../../Elements/Icon/Icon");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/jsx-props-no-spreading */

/**
 * Primary UI component for date input
 */
const DateInput = ({
  label,
  hint,
  optionalText,
  error,
  errorMsg,
  disabled,
  inputMode,
  fields,
  isStrict,
  setFocus,
  className,
  ...props
}) => {
  var _fields$find;
  const cssComponentClass = 'ccl__form-input';
  const cssTextClass = 'ccl__text';

  // ref the input field
  const dateInputs = fields.map(() => /*#__PURE__*/(0, _react.createRef)());

  // set focus to the field programatically if the prop matches the input date field

  (0, _react.useEffect)(() => {
    if (setFocus) {
      for (let i = 0; i < fields.length; i += 1) {
        if (setFocus === fields[i].id) {
          dateInputs[i].current.focus();
        }
      }
    }
  }, [setFocus]);
  function filterInput(e) {
    // entered value
    let checkThis = e.key;

    // check data being pasted
    if (e.type === 'paste') {
      // Get pasted data via clipboard API
      const clipboardData = e.clipboardData || window.clipboardData;
      checkThis = clipboardData.getData('Text');
    }
    const regex = /^\d+$/;
    if (!regex.test(checkThis)) {
      e.preventDefault();
      e.stopPropagation();
    }
  }
  const errorMessage = error ? errorMsg : (_fields$find = fields.find(({
    error: fieldError
  }) => !!fieldError)) == null ? void 0 : _fields$find.errorMsg;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: [cssComponentClass, `${cssComponentClass}--is-date-input`, error ? `${cssComponentClass}--has-error` : '', disabled ? `${cssComponentClass}--is-disabled` : '', className || ''].join(' '),
    ...props,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: `${cssComponentClass}__label ${cssTextClass} ${cssTextClass}--body-text-bold`,
      children: [label, optionalText && /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
        className: `${cssComponentClass}__label__optional ${cssTextClass} ${cssTextClass}--small-body-text-italic`,
        children: `(${optionalText})`
      })]
    }), hint && /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
      className: `${cssComponentClass}__hint ${cssTextClass} ${cssTextClass}--informative-text`,
      children: hint
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: `${cssComponentClass}--date-input`,
      children: fields.map((field, i) => /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: `ccl__field-control ${error || field.error ? `ccl__field-control--has-icon ccl__field-control--has-error` : ''}`,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("input", {
          ref: dateInputs[i],
          className: `ccl__field-control__input ${cssTextClass} ${cssTextClass}--body-text`,
          name: field.name,
          id: field.id || field.name,
          type: "text",
          defaultValue: field.stateManaged ? undefined : field.value,
          disabled: disabled || field.disabled,
          inputMode: inputMode,
          maxLength: field.maxLength,
          placeholder: field.floatLabel ? field.label : undefined,
          size: field.size,
          pattern: field.pattern,
          required: !optionalText,
          onBlur: field.onBlur,
          onChange: field.onChange,
          onFocus: field.onFocus,
          onKeyPress: event => isStrict && filterInput(event),
          onPaste: event => isStrict && filterInput(event),
          value: field.stateManaged ? field.value : undefined
        }), field.label && /*#__PURE__*/(0, _jsxRuntime.jsx)("label", {
          className: `${cssComponentClass}__label ${cssTextClass} ${cssTextClass}--small-body-text`,
          htmlFor: field.id || field.name,
          children: field.label
        })]
      }, field.name))
    }), errorMessage && /*#__PURE__*/(0, _jsxRuntime.jsxs)("p", {
      className: `${cssComponentClass}__error-message ${cssTextClass} ${cssTextClass}--error-small-text`,
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_Icon.Icon, {
        color: "error",
        type: "error",
        size: "xs"
      }), errorMessage]
    })]
  });
};
exports.DateInput = DateInput;
DateInput.defaultProps = {
  hint: '',
  optionalText: '',
  error: false,
  errorMsg: '',
  disabled: false,
  inputMode: 'text',
  pattern: '',
  isStrict: false,
  setFocus: ''
};